<fieldset class="ap-radio-group">
    <legend class="ap-radio-group__description" data-testid="description" [ngClass]="{ 'ap-sr-only': descriptionHidden() }">
        {{ description() }}
    </legend>

    <ng-content select="ap-context-explanation"></ng-content>

    @if (helpTextPosition() === HelpTextPosition.ABOVE && helpText()) {
        <ng-container *ngTemplateOutlet="helpTextElement; context: { above: true }"></ng-container>
    }

    <div class="ap-radio-group__wrapper" [ngClass]="{ 'ap-radio-group__wrapper--inline': inline() }">
        <ng-content></ng-content>
    </div>

    @if (helpTextPosition() === HelpTextPosition.BELOW && helpText() && !isErrorState) {
        <ng-container *ngTemplateOutlet="helpTextElement"></ng-container>
    }

    @if (control()) {
        <ap-form-errors
            data-testid="errors"
            [id]="errorsId"
            [control]="control()"
            [messages]="messages()"
            [content]="content"
        ></ap-form-errors>
    }
</fieldset>

<ng-template #helpTextElement let-above="above">
    <div
        class="ap-radio-group__help-text {{ above ? 'ap-radio-group__help-text--above' : 'ap-radio-group__help-text--below' }}"
        data-testid="help-text"
        [attr.id]="helpTextId"
        [innerHTML]="helpText()"
    ></div>
</ng-template>
